var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('router-view'),(_vm.footerState)?_c('foot-menu',{class:_vm.deepCont == '1' ? 'deepStyle' : '',attrs:{"deepLogoUrl":_vm.deepLogoUrl}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }